import { Plan } from '../../containers/shared/auth/rules';

/** Organisation plans that may open Metabase dashboards. Free and Standard may not. */
export const METABASE_PLANS: Plan[] = ['PREMIUM', 'BUSINESS', 'ENTERPRISE'];

export const METABASE_UPGRADE_MESSAGE =
  'This feature isn’t included in your current plan. Consider upgrading to Premium or higher to continue.';

export const hasMetabaseAccess = (plan?: string | null): boolean =>
  !!plan && (METABASE_PLANS as string[]).indexOf(plan) !== -1;

/** Where Admin > Dashboards opens. Lower plans land on the native layouts workspace. */
export const dashboardsEntryPath = (portal: string, plan?: string | null): string =>
  hasMetabaseAccess(plan) ? `/${portal}/manage/dashboards` : `/${portal}/manage/dashboards/workspace/default`;
